<template>
	<transition name="update-banner-slide">
		<div v-if="showBanner" class="update-banner" role="alert">
			<span class="update-banner-msg">새 버전이 배포되었습니다. 새로고침을 권장합니다.</span>
			<button type="button" class="update-banner-btn" @click="reload">새로고침</button>
			<button
				type="button"
				class="update-banner-close"
				aria-label="닫기"
				@click="dismiss"
			>×</button>
		</div>
	</transition>
</template>

<script>
import { startVersionPoll, stopVersionPoll } from '@/utils/buildVersion';

// PrintPage 류 라우트에서는 배너 표시 안 함 — puppeteer 가 PDF 로 캡처하는 영역에
// 배너가 끼면 출력물이 망가진다. 폴링 자체는 계속 돌아도 무해.
const PRINT_ROUTES = new Set([
	'PrintPage',
	'PrintPage2',
	'RentPrintPage',
	'RentPrintPage2',
]);

export default {
	name: 'UpdateBanner',
	data() {
		return {
			updateAvailable: false,
			dismissed: false,
		};
	},
	computed: {
		isPrintRoute() {
			const name = (this.$route && this.$route.name) || '';
			return PRINT_ROUTES.has(name);
		},
		showBanner() {
			return this.updateAvailable && !this.dismissed && !this.isPrintRoute;
		},
	},
	mounted() {
		startVersionPoll(() => {
			this.updateAvailable = true;
		});
	},
	beforeUnmount() {
		stopVersionPoll();
	},
	methods: {
		reload() {
			window.location.reload();
		},
		dismiss() {
			this.dismissed = true;
		},
	},
};
</script>

<style scoped>
.update-banner {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10000;
	background: #1976d2;
	color: #fff;
	padding: 10px 16px;
	display: flex;
	align-items: center;
	gap: 12px;
	font-size: 14px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.update-banner-msg {
	flex: 1;
	line-height: 1.4;
}

.update-banner-btn {
	background: #fff;
	color: #1976d2;
	border: none;
	padding: 6px 14px;
	border-radius: 4px;
	font-weight: 600;
	font-size: 13px;
	cursor: pointer;
}

.update-banner-btn:hover {
	background: #f0f0f0;
}

.update-banner-close {
	background: transparent;
	color: #fff;
	border: none;
	font-size: 22px;
	line-height: 1;
	padding: 0 4px;
	cursor: pointer;
}

.update-banner-close:hover {
	opacity: 0.8;
}

.update-banner-slide-enter-active,
.update-banner-slide-leave-active {
	transition: transform 0.3s ease, opacity 0.3s ease;
}

.update-banner-slide-enter-from,
.update-banner-slide-leave-to {
	transform: translateY(-100%);
	opacity: 0;
}

@media print {
	.update-banner {
		display: none !important;
	}
}
</style>
